var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,0C14.6,0,0,14.6,0,32.5S14.6,65,32.5,65S65,50.4,65,32.5C65,14.6,50.4,0,32.5,0z M46.1,25.2h-2l-6.2,7.2l6.2,7.2h2 v5.8H33v-5.8h2L30.9,35h-1.7v4.8h2.3v5.8H18.8v-5.8h2.8v-7.2v-7.3h-2.8v-5.8H22v2.2h1.7v-2.2h3.1v2.2h1.7v-2.2h3.1v5.7h-2.3v4.8h1.7 l4.1-4.8h-2v-5.7h13.2L46.1,25.2L46.1,25.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeep);
export default __webpack_public_path__ + "static/media/KEEP.fcc31cb6e5f91e441ee4d59b0de07d9c.svg";
export { ForwardRef as ReactComponent };